// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * Layout refresh event system
 *
 * Provides a simple event emitter for triggering layout refreshes across components.
 */

type LayoutRefreshListener = () => void

class LayoutEventEmitter {
  private listeners: Set<LayoutRefreshListener> = new Set()

  subscribe(listener: LayoutRefreshListener): () => void {
    this.listeners.add(listener)

    // Return unsubscribe function
    return () => {
      this.listeners.delete(listener)
    }
  }

  emit(): void {
    this.listeners.forEach(listener => listener())
  }
}

export const layoutEvents = new LayoutEventEmitter()

export const emitLayoutRefresh = () => {
  layoutEvents.emit()
}